import React, { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import AppBar from "../components/AppBar";
import Footer from "../components/Footer";

/**
 * The first page a user sees when they visit the site. This page should be a simple description of the
 * product and a call to action to sign up for the beta.
 */
function Landing(props) {
  const {} = useAuth();
  const [email, setEmail] = useState("");

  /**
   * Handle the call to action
   */
  const callToAction = () => {};

  return (
    <div>
      <AppBar />
      <div>
        <section>
          <div className="justify-center h-screen">
            <div className="w-full rounded-md p-16 flex flex-col justify-center items-center">
              <h1
                className="font-CerealXBd lg:text-4xl text-3xl mb-6 bg-gradient-to-r font-bold
                        animate-text"
              >
                Lecture Supercharged ⚡️
              </h1>
              <p className="font-CerealBK text-slate-500 mb-8 lg:text-center lg:text-lg text-md">
                 Search lecture, ask questions asyncronously, identify challenging concepts
              </p>
              <button className="btn-primary" onClick={callToAction}>
                Get Started
              </button>
            </div>
            <div class="min-h-screen w-full">
                <div class="h-full items-center justify-center  flex">
                    <iframe class="w-[700px] h-[450px]" src="https://www.loom.com/embed/c7659e7118284959aa12d834743e401d" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>


          </div>
        </section>
        </div>
    </div>
  );
}

export default Landing;
